import { connect } from "react-redux";
import Component from "./Stats";

export default connect(
    null,
    ({ scp: { viewTransactions }, alert: { silence } }) => ({ viewTransactions, silence })
)(Component);
